<div [@scaleIn] *ngIf="visible" class="dialog">

  <div class="row nav-container">
    <div class="col-lg-6 col-sm-12 d-flex justify-content-center">
      <ul class="nav flex-column">
        <li class="nav-item">
          <a class="btn nav-link" (click)="goto('/home')">Home</a>
        </li>
        <hr class="divider">

        <li class="nav-item">
          <a class=" btn nav-link" (click)="goto('/sponsors')">Sponsors</a>
        </li>
        <hr class="divider">

        <li [hidden]="isHidden" class="nav-item">
          <a class=" btn nav-link" (click)="goto('/reg-page')">Register Property</a>
        </li>
        <hr class="divider" [hidden]="isHidden">

        <li [hidden]="isHidden" class="nav-item">
          <a class=" btn nav-link" (click)="goto('/valuations')">My Valuations</a>
        </li>
        <hr class="divider" [hidden]="isHidden">
        
        <li class="nav-item m-t-2" [hidden]="!isHidden">
          <button type="button" (click)="onOwnerLogin()" class="btn btn-lg btn-teal rounded-pill shadow lift lift-sm btn_sign">Sign in as
            Owner</button>
        </li> <br>

        <li class="nav-item" [hidden]="!isHidden">
          <button type="button" (click)="onSponsorLogin()" class="btn btn-lg btn-teal rounded-pill shadow lift lift-sm btn_sign">Sign in as
            Sponsor</button>
        </li> <br>

        <li class="nav-item" [hidden]="!isHidden">
          <button type="button" (click)="onRegisterOwner()" class="btn btn-lg btn-teal rounded-pill shadow lift lift-sm btn_sign">Sign Up</button>
        </li>

        <li class="nav-item" [hidden]="isHidden">
          <button type="button" (click)="signOut()" class="btn btn-lg btn-teal rounded-pill shadow lift lift-sm btn_sign">Logout</button>
        </li>

      </ul>
    </div>
  </div>
  <button (click)="close()" aria-label="Close" class="dialog__close-btn">&#10006;</button>
</div>
<!-- <div class="overlay" (click)="close()"></div> -->
<app-signin [(visible)]="displayReg"></app-signin>
<app-login [(visible)]="displayLogin" (closeLogin)="closed($event)"></app-login>
<app-sponsors-login [(visible)]="displaySponsor"></app-sponsors-login>